import { DSCheckbox } from "@components/design-system/molecules";
import React from "react";

import { useNoteMultiselectContext } from "../../../hooks";
import Tooltip, {
  TooltipContainer,
} from "../../common/modals/Tooltip";
import {
  addSelectedNotes,
  removeSelectedNotes,
} from "../../common/multiselect/utils";

export default function NoteMultiSelector({
  checkBoxItemUuid,
  tooltipText,
  children,
  isStyled = true,
  isPatient,
}) {
  const {
    selectedNoteUuids,
    setSelectedNoteUuids,
    numSelectedNotes,
    setNumSelectedNotes,
    numPatientNotes,
    setNumPatientNotes,
  } = useNoteMultiselectContext();
  const isSelected = selectedNoteUuids[checkBoxItemUuid];

  return (
    <div
      className={
        isStyled
          ? `${
              isSelected
                ? "border-2 border-indigo-500 bg-indigo-500 dark:bg-indigo-500"
                : "border-2 border-transparent"
            } flex flex-1 rounded-lg items-center space-x-2 w-full`
          : `flex flex-1 items-center space-x-2 w-full`
      }
    >
      <Tooltip
        content={<TooltipContainer>{tooltipText}</TooltipContainer>}
      >
        <DSCheckbox
          checked={!!isSelected}
          onChange={() => {
            if (!isSelected) {
              addSelectedNotes({
                noteUuid: checkBoxItemUuid,
                selectedNoteUuids,
                setSelectedNoteUuids,
                numSelectedNotes,
                setNumSelectedNotes,
                numPatientNotes,
                setNumPatientNotes,
                isPatient,
              });
            } else {
              removeSelectedNotes({
                noteUuid: checkBoxItemUuid,
                selectedNoteUuids,
                setSelectedNoteUuids,
                numSelectedNotes,
                setNumSelectedNotes,
                numPatientNotes,
                setNumPatientNotes,
                isPatient,
              });
            }
          }}
          dataTestId={`note-multiselect-checkbox-${checkBoxItemUuid}`}
        />
      </Tooltip>
      {children}
    </div>
  );
}
